import { setI18nConfig } from '@front/i18n';

import { init as initRequester, setAuthorizationToken } from '../api/requester';
import { DEFAULT_LOCALE_BY_COUNTRY, LOCALES_BY_COUNTRY } from '../constants/country';
import { init as initDucks } from '../ducks/utils';
import { ErrorNotifier } from '../errors/error-notifier';

import { getCurrentCountry } from './country';
import { setMomentLocale } from './moment';

type InitializeArgs = {
  appName: string;
  authToken?: string | null;
  baseURL: string;
  errorNotifier: ErrorNotifier;
  i18nConfig: {
    translations: {
      fr: object;
      en: object;
    };
    locale: string;
  };
  setCountry: (() => Promise<void>) | (() => void);
  deviceUuid?: string;
};

export const initialize = async ({
  appName,
  authToken,
  baseURL,
  errorNotifier,
  i18nConfig,
  setCountry,
  deviceUuid,
}: InitializeArgs) => {
  await setCountry(); // frontend-specific way of setting the country (web vs mobile, ...)
  const country = getCurrentCountry(); // when country is set, this is the single common way of getting it

  setI18nConfig({
    ...i18nConfig,
    notifier: errorNotifier.notify,
    supportedLocales: LOCALES_BY_COUNTRY[country],
    defaultLocale: DEFAULT_LOCALE_BY_COUNTRY[country],
  });
  setMomentLocale();

  if (authToken) {
    setAuthorizationToken(authToken);
  }

  initRequester(baseURL, appName, deviceUuid);
  initDucks(errorNotifier);
};
